import { useQuery } from '@tanstack/react-query';
import { useCustomersSyncApi } from './use-customers-sync-api';
import { useCustomersSyncSettings } from './use-customers-sync-settings';

const QK_SALES_AGENT_GROUPS = () => ['customers-sync', 'sales-agent-groups'] as const;

export function useSalesAgentGroups(enabled: boolean) {
  const { customersSyncApi } = useCustomersSyncApi();
  const settings = useCustomersSyncSettings();

  return useQuery({
    queryKey: QK_SALES_AGENT_GROUPS(),
    queryFn: () => customersSyncApi.salesAgentGroups(settings),
    enabled,
  });
}
